<template>
  <div id="main-box" style="overflow:auto;">
    <div id="content-box">
      <el-card>
        <div>
          <el-form :inline="true">
            <el-form-item label="分销商:">
              <el-input size="small" v-model="queryForm.Name" placeholder="请输入分销商名称"></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-select size="small" v-model="queryForm.IsAccessInterface">
                <el-option :value="null" label="全部"></el-option>
                <el-option :value="true" label="已对接"></el-option>
                <el-option :value="false" label="未对接"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="结算方式">
              <el-select size="small" v-model="queryForm.SettlementType">
                <el-option :value="null" label="全部"></el-option>
                <el-option :value="0" label="先货后款"></el-option>
                <el-option :value="1" label="先款后货"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="search">筛选</el-button>
              <el-button size="small" @click="empty">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div style="padding-bottom: 15px;">
          <toolbar
              :buttonList="buttonList_toolBar"
              @callFunction="callFunction"
          ></toolbar>
        </div>
        <el-table
          :data="saleList"
          highlight-current-row
          v-loading="tableLoading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          @selection-change="handleSelectionChange"
          style="width: 100%"
          border
        >
          <el-table-column
            prop="id"
            label="分销商ID"
            min-width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="name"
            label="分销商名称"
            min-width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            label="API对接状态"
            min-width="180"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.isAccessInterface ? '已对接' : '未对接' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="synchronizedProductNum"
            label="已同步商品"
            min-width="180"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="notSynchronizedProductNum"
            label="未同步商品"
            min-width="180"
            align="center"
          ></el-table-column>
          <el-table-column
            label="结算方式"
            min-width="180"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.settlementType == 0">先货后款</span>
              <span v-if="scope.row.settlementType == 1">先款后货</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="creationTime"
            label="创建时间"
            min-width="180"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" align="center" min-width="280" fixed="right">
            <template slot-scope="scope">
              <toolbar
                :buttonList="buttonList_table"
                :funcParams="scope.row"
                @callFunction="callFunction"
              ></toolbar>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          style="float: right"
          :total="total"
          :current-page="queryForm.pageIndex"
          :pageSize="queryForm.pageSize"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        ></el-pagination>
      </el-card>
    </div>

    <el-dialog
      :title="isEdit ? '编辑' : '添加分销商'"
      :visible.sync="distributorDialog"
      v-if="distributorDialog"
      v-model="distributorDialog"
      :close-on-click-modal="false"
    >
      <el-form
        :model="distributorForm"
        label-width="120px"
        :rules="distributorFormRules"
        ref="distributorForm"
      >
        <el-form-item label="分销商名称" prop="name">
          <el-input v-model="distributorForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-radio-group v-model="distributorForm.isActive">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="结算方式" prop="settlementType">
          <el-select size="small" v-model="distributorForm.settlementType" placeholder="请选择">
            <el-option :value="0" label="先货后款"></el-option>
            <el-option :value="1" label="先款后货"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="外部系统key" prop="remoteKey">
          <el-input v-model="distributorForm.remoteKey" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="开票信息">
        </el-form-item>
        <el-form-item label="发票类型">
          <el-input v-model="distributorForm.remoteKey" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="发票抬头" >
          <el-input v-model="distributorForm.remoteKey" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号">
          <el-input v-model="distributorForm.remoteKey" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="地址">
          <el-input
              type="textarea"
              autosize
              placeholder="请输入内容"
              v-model="distributorForm.remoteKey">
          </el-input>
        </el-form-item>
        <el-form-item label="开户行">
          <el-input
              type="textarea"
              autosize
              placeholder="请输入内容"
              v-model="distributorForm.remoteKey">
          </el-input>
        </el-form-item>
        <el-form-item label="银行账户">
          <el-input v-model="distributorForm.remoteKey" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="distributorForm.remoteKey" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="自定义扩展">
          <div id="extend-content"></div>
          <div class="option">
            <div class="btn" @click="addExtension">+添加扩展</div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="distributorDialog = false">取消</el-button>
        <el-button type="primary" @click.native="submitDistributor">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="绑定系统分销商"
      :visible.sync="sysDistributorDialog"
      v-if="sysDistributorDialog"
      v-model="sysDistributorDialog"
      :close-on-click-modal="false"
    >
      <el-form
        :model="sysDistributorForm"
        label-width="120px"
        :rules="sysDistributorFormRules"
        ref="sysDistributorForm"
      >
        <el-form-item label="系统分销商" prop="sysResellerId">
          <el-select
            filterable
            remote
            v-model="sysDistributorForm.sysResellerId"
            placeholder="请选择系统分销商（可搜索）"
            clearable
          >
            <el-option
              v-for="(item,index) in sysDistributorList"
              :key="index"
              :label="item.displayName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="sysDistributorDialog = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click.native="submitSysDistributor">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  CreateReseller,
  UpdateReseller,
  GetAllReseller,
  GetResellerDetail,
  DeleteReseller,
  GetAllSysReseller,
  BindSysReseller
} from "../../api/api";
import toolbar from "../../components/Toolbar";
import {getButtonList} from "../../promissionRouter";
export default {
  components: {toolbar},
  data() {
    return {
      buttonList_toolBar: [],
      buttonList_table: [],
      tableLoading: false,
      submitLoading: false,

      currentRow: [],
      total: 0,
      queryForm: {
        Name: null,
        IsAccessInterface: null,
        SettlementType: null,
        pageIndex: 1,
        pageSize: 10
      },
      saleList: [{id:1}],

      distributorDialog: false,
      isEdit: false,
      distributorForm: {
        name: null,
        settlementType: null,
        isActive: true,
        remoteKey: null,
        extensionJson: null
      },
      distributorFormRules: {
        name: [
          { required: true, message: '请输入分销商名称', trigger: 'blur' },
          { message: '请输入分销商名称', trigger: ['blur', 'change'] }
        ],
        settlementType: [
          { required: true, message: '请选择结算方式', trigger: 'change' }
        ],
        remoteKey: [
          { required: true, message: '请输入外部系统key', trigger: 'blur' },
          { message: '请输入外部系统key', trigger: ['blur', 'change'] }
        ]
      },

      sysDistributorDialog: false,
      sysDistributorForm: {
        id: null,
        sysResellerId: null
      },
      sysDistributorFormRules: {
        sysResellerId: [
          { required: true, message: '请选择系统分销商', trigger: 'change' }
        ]
      }
    };
  },
  mounted() {
    window.deleteExtendBox = this.deleteExtendBox;
    this.getsysDistributorList();
    this.getSaleList();
    this.renderButton();
  },
  methods: {
    emptyErrStyle(elements) {
      for (var i = 0, len = elements.length; i < len; i++) {
        let input = elements[i];
        let extendBox = input.closest('.extend-box');
        input.classList.remove("input-err");
        extendBox.classList.remove("box-err");
      }
    },
    addExtension() {
      let html = `
        <div class="extend-box">
          key：&nbsp;&nbsp;
          <input class="input-piece1" type="text">
          &nbsp;&nbsp;value：&nbsp;&nbsp;
          <input class="input-piece1" type="text">
          <div class="delete-icon" onclick="deleteExtendBox(this)">
            <img />
          </div>
        </div>
      `;
      let rebateContent = document.getElementById('extend-content');
      rebateContent.insertAdjacentHTML('beforeend', html);
    },
    deleteExtendBox(e) {
      let parent = e.closest('.extend-box');
      parent.parentNode.removeChild(parent);
    },
    getsysDistributorList() {
      let params = {
        SkipCount: 0,
        MaxResultCount: 200
      };
      GetAllSysReseller(params).then((res) => {
        if (res.data.success) {
          this.sysDistributorList = res.data.result.items;
        }
      });
    },
    bindSysDistributor(params) {
      let row = params.funcParams;
      this.sysDistributorForm.id = row.id;
      this.sysDistributorForm.sysResellerId = row.sysResellerId;
      this.sysDistributorDialog = true;
    },
    submitSysDistributor() {
      let that = this;
      that.$refs.sysDistributorForm.validate((valid) => {
        if (valid) {
          that.$confirm("确认提交吗？", "提示", {
            closeOnClickModal: false,
          }).then(() => {
            that.submitLoading = true;
            BindSysReseller(that.sysDistributorForm).then((res) => {
              that.submitLoading = false;
              if (res.data.success) {
                that.$message.success('绑定成功');
                that.sysDistributorDialog = false;
                that.getSaleList();
              } else {
                that.$message.error(res.data.error.message);
              }
            });
          }).catch(() => {});
        }
      });
    },
    getSaleList() {
      this.queryForm.SkipCount = (this.queryForm.pageIndex - 1) * this.queryForm.pageSize;
      console.log('this.queryForm.SkipCount',this.queryForm.SkipCount)
      this.queryForm.MaxResultCount = this.queryForm.pageSize;
      let that = this;
      this.tableLoading = true;
      GetAllReseller(this.queryForm).then((res) => {
        that.tableLoading = false;
        that.total = res.data.result.totalCount;
        that.saleList = res.data.result.items;
      });
    },
    handleSelectionChange(val) {
      this.currentRow = val;
    },
    handleCurrentChange(val) {
      this.queryForm.pageIndex = val;
      this.getSaleList();
    },
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.getSaleList();
    },
    search() {
      this.queryForm.pageIndex = 1;
      this.queryForm.pageSize = 10;
      this.getSaleList();
    },
    empty() {
      this.queryForm.Name = null;
      this.queryForm.IsAccessInterface = null;
      this.queryForm.SettlementType = null;
      this.queryForm.pageIndex = 1;
      this.queryForm.pageSize = 10;
      this.getSaleList();
    },
    // 分销商添加
    addDistributor() {
      this.isEdit = false;
      this.distributorForm.name = null;
      this.distributorForm.settlementType = null;
      this.distributorForm.isActive = true;
      this.distributorForm.remoteKey = null;
      this.distributorForm.extensionJson = null;
      this.distributorDialog = true;
    },
    // 分销商编辑
    editDistributor(btnParams) {
      let row = btnParams.funcParams;
      let params = { Id: row.id };
      let that = this;
      GetResellerDetail(params).then((res) => {
        if (res.data.success) {
          that.distributorForm = res.data.result;
          that.isEdit = true;
          that.distributorDialog = true;
          this.$nextTick(() => {
            let extendData = JSON.parse(this.distributorForm.extensionJson);
            if (extendData.length > 0) {
              let html = "";
              for (var i = 0; i < extendData.length; i++) {
                var el = extendData[i];
                let key = el.key;
                let value = el.value;
                html += "<div class=\"extend-box\">key：&nbsp;&nbsp;<input class=\"input-piece1\" type=\"text\" value="+key+">&nbsp;&nbsp;value：&nbsp;&nbsp;<input class=\"input-piece1\" type=\"text\" value="+value+"><div class=\"delete-icon\" onclick=\"deleteExtendBox(this)\"><img /></div></div>";
              }
              let rebateContent = document.getElementById('extend-content');
              rebateContent.insertAdjacentHTML('beforeend', html);
            }
          });
        } else {
          that.$message.error(res.data.error.message);
        }
      });
    },
    submitDistributor() {
      let that = this;
      that.$refs.distributorForm.validate((valid) => {
        if (valid) {
          that.$confirm("确认提交吗？", "提示", {
            closeOnClickModal: false,
          }).then(() => {

            // 处理扩展字段
            var elements = document.querySelectorAll('#extend-content input');
            this.emptyErrStyle(elements);
            for (var i = 0, len = elements.length; i < len; i++) {
              let input = elements[i];
              if (input.value == "") {
                let extendBox = input.closest('.extend-box');
                this.$message.error('不能为空');
                input.classList.add("input-err");
                extendBox.classList.add("box-err");
                return;
              }
            }
            this.extendList = [];
            for (var i = 0, len = elements.length; i < len; i++) {
              this.extendList.push({
                key: elements[i].value,
                value: elements[i + 1].value
              });
              i += 1;
            }
            that.distributorForm.extensionJson = JSON.stringify(this.extendList);

            this.tableLoading = true;
            if (!that.isEdit) {
              CreateReseller(that.distributorForm).then((res) => {
                that.submitLoading = false;
                if (res.data.success) {
                  that.$message.success('添加成功');
                  that.distributorDialog = false;
                  that.getSaleList();
                } else {
                  that.$message.error(res.data.error.message);
                }
              });
            } else {
              UpdateReseller(that.distributorForm).then((res) => {
                that.submitLoading = false;
                if (res.data.success) {
                  that.$message.success('修改成功');
                  that.distributorDialog = false;
                  that.getSaleList();
                } else {
                  that.$message.error(res.data.error.message);
                }
              });
            }
          }).catch(() => {});
        }
      });
    },
    // 授权商品
    licensedGoods(params) {
      let row = params.funcParams;
      this.$router.push(`/Sale/LicensedGoods?distributorId=${row.id}&distributorName=${row.name}`);
    },
    // 一键同步
    oneKeySync() {},
    // 店铺管理
    shopManage() {},
    // 合同管理
    contractManage() {},
    renderButton() {
      let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
      var buttonList = getButtonList(this.$route.path, routers);
      this.buttonList_toolBar = buttonList.filter((item) => {
        return item.buttonShow == 10 && item.isVisible;
      });
      this.buttonList_table = this.$utils.sortDataArrayAsc(buttonList.filter((item) => {
        return item.buttonShow == 20 && item.isVisible;
      }), 'order');
    },
    callFunction(item) {
      this[item.buttonFunc](item);
    },
    handleDel(btnParams) {
      let row = btnParams.funcParams;
      let params = { Id: row.id };
      this.$confirm("确认删除吗？", "提示", {
        closeOnClickModal: false,
      }).then(() => {
        DeleteReseller(params).then(res => {
          if (res.data.success) {
            this.$message.success('删除成功');
            this.getSaleList();
          } else {
            this.$message.error(res.data.error.message);
          }
        })
      })
    }
  }
};
</script>
<style scoped>
#main-box
{
  width: 100%;
  height:100%;
}
#content-box
{
  padding: 0 20px 20px 20px;
  width: 100%;
  height: 100%;
}
#main-box /deep/ .el-pagination {
  padding: 10px 5px;
}

#main-box /deep/ #extend-content {
  padding: 20px 0 0 0;
  max-height: 200px;
  overflow-y: auto;
}
#main-box /deep/ #extend-content::-webkit-scrollbar {
 width: 8px;
}
#main-box /deep/ #extend-content::-webkit-scrollbar-track {
 background-color:#F1F1F1;
 -webkit-border-radius: 2em;
 -moz-border-radius: 2em;
 border-radius:2em;
}
#main-box /deep/ #extend-content::-webkit-scrollbar-thumb {
 background-color:#C1C1C1;
 -webkit-border-radius: 2em;
 -moz-border-radius: 2em;
 border-radius:2em;
}
#main-box /deep/ .extend-box {
  width: 360px;
  height: 34px;
  position:relative;
  display:flex;
  justify-content: flex-start;
  border-radius: 6px;
  padding: 3px 10px;
}
#main-box /deep/ .extend-box.box-err {
  background-color: #FEF0F0;
}
#main-box /deep/ .extend-box input {
  width: 70px !important;
  height: 100% !important;
  line-height: 36px;
  -webkit-appearance: none;
  background-color: #FFF;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
#main-box /deep/ .extend-box input.input-err {
  border: #F56C6C solid 1px;
}
#main-box /deep/ .delete-icon {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 15px;
}
#main-box /deep/ .delete-icon img {
  width: 20px;
  height: 20px;
  content: url(../../assets/close.png);
  cursor: pointer;
}
#main-box /deep/ .delete-icon img:hover {
  transform: scale(1.2);
}
#main-box /deep/ .option {
  width: 330px;
  display: flex;
  justify-content: space-between;
}
#main-box /deep/ .option .btn {
  color:#409EFF;
  cursor: pointer;
}
#main-box /deep/ .el-dialog__body {
  padding: 10px 20px 0 20px;
}
#main-box /deep/ .el-dialog__body .el-form-item {
  margin-bottom: 15px;
}
#main-box /deep/ .el-dialog__footer {
  padding: 0 20px 20px 20px;
}
#main-box /deep/ .dialog-footer {
  padding: 0 20px 0 20px;
}
</style>
